import Vue from 'vue';
import Tether from 'tether';

let tooltipCounter = 0;
/** @type {Map<any, ManagedTooltip>} */
const tooltips = new Map();

class ManagedTooltip {
    target;
    tether;
    element;
    content;
    boundMouseEnter;
    boundMouseLeave;
    attachment = 'bottom center';
    targetAttachment = 'top center';
    targetOffset = '-15px 0';
    classes = [];
    arrowBefore = false;

    constructor(el) {
        this.target = el;
        this.boundMouseEnter = () => this.show();
        this.boundMouseLeave = () => this.hide();
        this.target.addEventListener('mouseenter', this.boundMouseEnter);
        this.target.addEventListener('mouseleave', this.boundMouseLeave);
    }

    destroy() {
        if (this.tether) {
            this.tether.destroy();
            this.tether = null;
        }
        if (this.element) {
            this.element.remove();
            this.element = null;
        }
        this.target.removeEventListener('mouseenter', this.boundMouseEnter);
        this.target.removeEventListener('mouseleave', this.boundMouseLeave);
    }

    show() {
        if (!this.content) {
            return;
        }
        if (this.tether) {
            this.tether.destroy();
        }
        if (!this.element) {
            let element = document.createElement('div');
            element.innerHTML = `
<div class="vrm-tooltip">
<div class="vrm-tooltip__content">${this.content}</div>
</div>
`;
            element = element.firstElementChild;
            const arrowHTML = `<div class="vrm-tooltip__arrow"><div class="vrm-tooltip__arrow-inner"></div></div>`;
            if (this.arrowBefore) {
                element.innerHTML = arrowHTML + element.innerHTML;
            } else {
                element.innerHTML = element.innerHTML + arrowHTML;
            }
            this.target.append(element);
            this.element = element;
            this.target.append(this.element);
            this.classes.forEach(name => this.element.classList.add(name));
        } else {
            this.element.classList.remove('vrm-remove');
        }

        const options = {
            element: this.element,
            target: this.target,
            attachment: this.attachment,
            targetAttachment: this.targetAttachment,
            targetOffset: this.targetOffset,
            constraints: [
                {
                    to: 'window',
                    pin: ['left', 'right'],
                },
            ],
        };
        this.tether = new Tether(options);
    }

    hide() {
        if (this.tether) {
            this.tether.destroy();
        }
        if (this.element) {
            this.element.classList.add('vrm-remove');
        }
    }

    updateContents(html) {
        this.content = html;
        if (this.element) {
            if (html) {
                this.element.classList.remove('vrm-tooltip--empty');
                const containers = this.element.getElementsByClassName('vrm-tooltip__content');
                containers[0].innerHTML = html;
            } else {
                this.element.classList.add('vrm-tooltip--empty');
            }
        }
    }
}

Vue.directive('tooltip', {
    bind: function(el, bindings) {
        const tooltipId = `${++tooltipCounter}`;
        el.dataset.vTooltipId = tooltipId;
        const tooltip = new ManagedTooltip(el);
        tooltips.set(tooltipId, tooltip);

        if (el.dataset.tooltipClass) {
            const classes = el.dataset.tooltipClass.split(' ');
            tooltip.classes.push(...classes);
        }

        if (bindings.modifiers.bottom) {
            tooltip.attachment = 'top center';
            tooltip.targetAttachment = 'bottom center';
            tooltip.arrowBefore = true;
            tooltip.classes.push('vrm-tooltip--bottom');
        }
        if (bindings.value) {
            tooltip.updateContents(bindings.value);
        }
    },
    update: function(el, bindings) {
        const tooltipId = el.dataset.vTooltipId;
        const tooltip = tooltips.get(tooltipId);
        if (tooltip && bindings.value !== bindings.oldValue) {
            tooltip.updateContents(bindings.value);
        }
    },
    unbind: function(el) {
        const tooltipId = el.dataset.vTooltipId;
        const tooltip = tooltips.get(tooltipId);
        if (tooltip) {
            tooltip.destroy();
            tooltips.delete(tooltipId);
        }
    },
});
